require.context('./static', true, /\.(svg|png|webp)$/);
import './index.scss';
